// utils/getSplashMessage.js
import { splash_messages } from './splashMessages';

export function getRandomMessage(theme = null) {
  const themes = Object.keys(splash_messages);

  const selectedTheme = 
    theme && splash_messages[theme] 
      ? theme 
      : themes[Math.floor(Math.random() * themes.length)];

  const entries = Object.entries(splash_messages[selectedTheme]); 
  const [id, text] = entries[Math.floor(Math.random() * entries.length)]; 
  
  return { id, text };

  //const messages = Object.values(splash_messages[selectedTheme]);
  //return messages[Math.floor(Math.random() * messages.length)];

}
